import { PureComponent, ReactNode } from 'react';
import { DentalProcedure } from '../../../../../store/types/prescription';
import { columnHeaderContent, headerStyle } from '../../../../common/TableUtils';
import { Table } from 'antd';
import Column from 'antd/lib/table/Column';
import moment from 'moment';

interface Props {
    treatmentProcedures: DentalProcedure[];
}

class WorkDoneTable extends PureComponent<Props> {
    seqHeaderContent = columnHeaderContent('');
    nameHeaderContent = columnHeaderContent('Procedure');
    toothHeaderContent = columnHeaderContent('Tooth');
    areaHeaderContent = columnHeaderContent('Area');
    visitsHeaderContent = columnHeaderContent('Visits');
    dateHeaderContent = columnHeaderContent('Date');
    remarksHeaderContent = columnHeaderContent('Remarks');

    renderSeq = (_: DentalProcedure, __: DentalProcedure, index: number) => {
        return <p>{index + 1}</p>;
    };

    renderName = (service: DentalProcedure) => {
        const { name } = service;
        return <p>{name}</p>;
    };

    renderTooth = (service: DentalProcedure) => {
        const { teeth_ids } = service;
        return <p>{teeth_ids?.join(', ') || '-'}</p>;
    };

    renderArea = (service: DentalProcedure) => {
        const { surfaces } = service;
        return <p>{surfaces?.map((i) => i.name).join(', ') || '-'}</p>;
    };

    renderVisits = (service: DentalProcedure) => {
        const { visits } = service;
        return <p>{visits || '-'}</p>;
    };

    renderDate = (service: DentalProcedure) => {
        const { start_on } = service;
        return <p>{start_on ? moment(start_on).format('Do MMM YY') : '-'}</p>;
    };

    renderRemarks = (service: DentalProcedure) => {
        const { remark, conducted_by, assisted_by } = service;
        return (
            <div className="space-y-3">
                <p>{remark ? remark : conducted_by || assisted_by ? '' : '-'}</p>
                {conducted_by && <p>Conducted By: {conducted_by}</p>}
                {assisted_by && <p>Assisted By: {assisted_by}</p>}
            </div>
        );
    };

    render(): ReactNode {
        const { treatmentProcedures } = this.props;
        const defaultHeaderStyle = headerStyle().style;
        const showColumns: { [key: string]: boolean } = {};
        treatmentProcedures.forEach(
            ({ teeth_ids, surfaces, visits, start_on, remark, conducted_by, assisted_by }) => {
                if (teeth_ids && teeth_ids?.length > 0) {
                    showColumns['teeth_ids'] = true;
                }
                if (surfaces && surfaces?.length > 0) {
                    showColumns['surfaces'] = true;
                }
                if (visits) {
                    showColumns['visits'] = true;
                }
                if (start_on) {
                    showColumns['start_on'] = true;
                }
                if (remark || conducted_by || assisted_by) {
                    showColumns['remark'] = true;
                }
            },
        );

        return treatmentProcedures.length > 0 ? (
            <Table
                dataSource={treatmentProcedures}
                className="border-darwin-neutral_new-200"
                pagination={false}
                bordered
            >
                <Column
                    title={this.seqHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            width: '6.5%',
                        },
                    })}
                    key="work-done-row-seq"
                    render={this.renderSeq}
                />
                <Column
                    title={this.nameHeaderContent}
                    onHeaderCell={() => ({
                        style: {
                            ...defaultHeaderStyle,
                            minWidth: '25%',
                        },
                    })}
                    key="work-done-row-name"
                    render={this.renderName}
                />
                {showColumns['teeth_ids'] && (
                    <Column
                        title={this.toothHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '15%',
                            },
                        })}
                        key="work-done-row-tooth"
                        render={this.renderTooth}
                    />
                )}
                {showColumns['surfaces'] && (
                    <Column
                        title={this.areaHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '15%',
                            },
                        })}
                        key="work-done-row-area"
                        render={this.renderArea}
                    />
                )}
                {showColumns['visits'] && (
                    <Column
                        title={this.visitsHeaderContent}
                        onHeaderCell={headerStyle}
                        key="work-done-row-visits"
                        render={this.renderVisits}
                    />
                )}
                {showColumns['start_on'] && (
                    <Column
                        title={this.dateHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                width: '120px',
                            },
                        })}
                        key="work-done-row-date"
                        render={this.renderDate}
                    />
                )}
                {showColumns['remark'] && (
                    <Column
                        title={this.remarksHeaderContent}
                        onHeaderCell={() => ({
                            style: {
                                ...defaultHeaderStyle,
                                minWidth: '15%',
                            },
                        })}
                        key="work-done-row-remarks"
                        render={this.renderRemarks}
                    />
                )}
            </Table>
        ) : (
            <p>No treatments or procedures added</p>
        );
    }
}

export default WorkDoneTable;
